<template>
  <div>
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/Admin' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>VIP价格列表</el-breadcrumb-item>
    </el-breadcrumb>
    <el-card class="box-card">
      <el-row class="form-row">
        <el-text style="width:100px; text-align: right;">名称：</el-text>
        <el-col :span="4">
          <el-input placeholder="请输入名称" style="width:400px;" v-model="subData.name"></el-input>
        </el-col>
      </el-row>
      <el-row class="form-row">
        <el-text style="width:100px; text-align: right;">价格：</el-text>
        <el-col :span="4">
          <el-input placeholder="请输入价格" style="width:400px;" v-model="subData.price"></el-input>
        </el-col>
      </el-row>
			<el-row class="form-row">
				<el-text style="width:100px; text-align: right;">类型：</el-text>
				<el-col :span="21" style="overflow:hidden; line-height:30px;">
          <el-radio-group v-model="subData.timeType">
            <el-radio :label="tItem.id" v-for="tItem in typeList">{{ tItem.name }}</el-radio>
          </el-radio-group>
				</el-col>
			</el-row>
      <el-row class="form-row">
        <el-text style="width:100px; text-align: right;">时长：</el-text>
        <el-col :span="4">
          <el-input placeholder="请输入时长" style="width:400px;" v-model="subData.timeLength"></el-input>
        </el-col>
      </el-row>
			<el-row class="form-row">
				<el-text style="width:100px; text-align: right;">状态：</el-text>
				<el-col :span="21" style="overflow:hidden; line-height:30px;">
          <el-radio-group v-model="subData.isShow">
            <el-radio :label="1">启用</el-radio>
            <el-radio :label="0">禁用</el-radio>
          </el-radio-group>
				</el-col>
			</el-row>

      <el-row class="bt" style="padding:15px 0; padding-left: 100px;">
        <el-button type="primary" @click="submitEvent">确定</el-button>
        <el-button plain type="primary" @click="backEvent">返回</el-button>
      </el-row>
    </el-card>
  </div>
</template>

  
<script>

export default {
  data() {
    return {
      id: this.$route.query.id?this.$route.query.id:0,
      subData:{
        name : '',
        price : '',
        timeType : '',
        timeLength : '',
        isShow : '',

      },
      typeList:[{
          'id': '天',
          'name':'天'
        },{
          'id': '月',
          'name':'月'
        },{
          'id': '季',
          'name':'季'
        },{
          'id': '年',
          'name':'年'
      }],
      stateList:[{
        'id': '0',
        'name':'禁用'
      },{
        'id': '1',
        'name':'启用'
      }]
    }
  },
  mounted:function(){
    if(this.id>0){
      this.getData()
    }
  },
  methods: {
    backEvent(){
        this.$router.go(-1)
    },
    getData(){
      var ths = this
      ths.$get('/VipPrices/queryById?id='+ths.id)
      .then(function (res) { 
          if(res.success){
            ths.subData = res.data
          }
      })
      .catch(function (err) {
        console.log(err)
      })    
    },
    submitEvent() {
      const ths = this;

      ths.$post('/VipPrices/edit?', ths.subData)
        .then(function (res) { 
            alert(res.msg)
            if(res.success){
              ths.$router.push("/Admin/VipPricesList")
            }
        })
        .catch(function (err) {
          console.log(err)
        })      
      },
   }
}

</script>

<style>
.form-row{
  padding:15px 0; 
}
</style>